const state = {
  polyPhoneModalVisible: false,
};

const getters = {};
const mutations = {
  setData(state, { key, value }) {
    state[key] = value;
  },
  distinguishSetData(state, { key, value }) {
    state[key] = value;
  },
};
const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
